// extracted by mini-css-extract-plugin
module.exports = {"Image":"ImportListProductVariantImageSelector_Image__QcVpZ"};